import digitalData from 'digital-data';
export const aisleBay = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('aisle-bay.open', _ref => {
    let {
      output
    } = _ref;
    const DDOEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {}
    };
    DDOEvent.category.primaryCategory = 'interaction';
    DDOEvent.eventInfo.eventName = 'pip sub-content';
    DDOEvent.subContent = {
      section: 'buybox',
      component: 'custom options',
      target: 'text me'
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('aisle-bay.success', _ref2 => {
    let {
      output
    } = _ref2;
    const DDOEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {}
    };
    DDOEvent.category.primaryCategory = 'button submission';
    DDOEvent.eventInfo.eventName = 'text me';
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('aisle-bay.error', _ref3 => {
    let {
      output
    } = _ref3;
    const {
      type,
      data
    } = output;
    const DDOEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {}
    };
    const isClientError = (data === null || data === void 0 ? void 0 : data.code) >= 400 && (data === null || data === void 0 ? void 0 : data.code) < 500;
    DDOEvent.category.primaryCategory = 'error';
    DDOEvent.eventInfo.error = {
      code: (data === null || data === void 0 ? void 0 : data.code) || '',
      displayType: 'inline',
      message: (data === null || data === void 0 ? void 0 : data.message) || '',
      pageSection: 'aisle and bay',
      type: isClientError ? 'client' : 'system'
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
//# sourceMappingURL=aisle-bay.listener.analytics.js.map